// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyD1kp8WRCcHWmeLHuNqcnOPKADVFIf9E4k",
  authDomain: "eventovirutalgama.firebaseapp.com",
  projectId: "eventovirutalgama",
  storageBucket: "eventovirutalgama.appspot.com",
  messagingSenderId: "641855455030",
  appId: "1:641855455030:web:0e9bcb52de800635527d97",
  measurementId: "G-KW2B4RVKX3"
}
// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/eventovirutalgama.appspot.com/o/'